import React, { useState, useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { Flex, Row, Image, Form, Button, Spin } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { getParamsApi, getApi } from "../services/api.jsx";
import "../styles/fonts.css";

const BadgePreviewDesktop = () => {
  const [badgeData, setBadgeData] = useState("");
  const [loading, setLoading] = useState(false);
  const [yinzcamId, setYinzcamId] = useState(
    localStorage.getItem("yinzcamId") || ""
  );
  const [email, setEmail] = useState(localStorage.getItem("email") || "");
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const isEarned = queryParams.get("isEarned") === "true";
  const { id } = useParams();
  const navigate = useNavigate();
  const [imageLoading, setImageLoading] = useState(true);

  const goHomeButton = () => {
    if (yinzcamId && email) {
      navigate(
        `/main-desktop?yinzcamId=${encodeURIComponent(yinzcamId)}&email=${encodeURIComponent(email)}`,
      );
    } else {
      navigate("/main-desktop");
    }
  };

  const getBadgeData = (badgeId) => {
    const params = { id: badgeId };
    getParamsApi(`/badge/${badgeId}`, params)
      .then((response) => {
        setBadgeData(response);

        // Send GA4 event for badge detail view
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'badge_detail_view',
          'badge_id': response.id,
          'badge_name': response.name,
          'badge_category': response.categoryId,
          'is_earned': isEarned,
          'user_id': yinzcamId || 'anonymous',
          'user_email': email || 'anonymous',
          'view_timestamp': new Date().toISOString(),
          'device_type': 'desktop',
        });
        // 'ga4_measurement_id': 'G-EC4X5M443P'


        // if (window.gtag) {
        //   window.gtag('event', 'badge_detail_view', {
        //     'badge_id': response.id,
        //     'badge_name': response.name,
        //     'badge_category': response.categoryId,
        //     'is_earned': isEarned,
        //     'user_id': yinzcamId || 'anonymous',
        //     'user_email': email || 'anonymous',
        //     'view_timestamp': new Date().toISOString(),
        //     'device_type': 'desktop'
        //   });
        // }
      })
      .catch((error) => {
        console.error("Error fetching badge data:", error);
      });
  };

  useEffect(() => {
    getBadgeData(id);
  }, [id]);

  useEffect(() => {
    if (badgeData.name) {
      document.title = badgeData.name;
    }
  }, [badgeData.name]);

  return (
    <>
      <div
        style={{
          backgroundImage: badgeData.backgroundImageURL
            ? `url(${badgeData.backgroundImageURL})`
            : "none",
          backgroundSize: "cover",
          backgroundColor: badgeData.backgroundColor
            ? badgeData.backgroundColor
            : "#000",
          textAlign: "center",
          width: "100vw",
          flexDirection: "column",
        }}
        className="w-100 h-100"
        vertical
        justify="space-between"
      >
        <>
          {" "}
          <a
            onClick={goHomeButton}
            rel="noopener noreferrer"
            style={{
              color: "white",
              display: "flex",
              alignItems: "center",
              fontSize: "13px",
              textDecoration: "none",
            }}
          >
            <ArrowLeftOutlined
              style={{
                display: "flex",
                padding: "10px",
                fontSize: "18px",
                color: "white",
              }}
            />
            <span>Home</span>
          </a>
          <div className="text-center p-15">
            {imageLoading && (
              <div style={{ 
                width: "250px", 
                height: "250px", 
                display: "flex", 
                alignItems: "center", 
                justifyContent: "center",
                margin: "0 auto"
              }}>
                <Spin size="large" />
              </div>
            )}
            <Image
              src={badgeData.imageURL}
              alt="Badge"
              style={{
                width: "250px",
                height: "250px",
                opacity: isEarned ? 1 : 0.4,
                display: imageLoading ? "none" : "block"
              }}
              onLoad={() => setImageLoading(false)}
              onError={() => setImageLoading(false)}
            />
            <h3
              style={{
                color: badgeData.headlineFontColor || badgeData.fontColor || "#fff",
                fontSize: badgeData.headlineFontSize ? `${badgeData.headlineFontSize}px` : 'inherit',
                fontFamily: badgeData.font ? `"${badgeData.font}"` : 'inherit',
                padding: "0 15px"
              }}
            >
              {badgeData.headline}
            </h3>
            <div
              style={{
                color: badgeData.fontColor || "#fff",
                fontSize: badgeData.fontSize ? `${badgeData.fontSize}px` : 'inherit',
                fontFamily: badgeData.font ? `"${badgeData.font}"` : 'inherit',
                padding: "0 20px"
              }}
              dangerouslySetInnerHTML={{
                __html: badgeData.description,
              }}
            />
            {badgeData.buttonName && (
              <Button
                type="primary"
                className="no-radius"
                style={{
                  backgroundColor: badgeData.buttonColor,
                  color: badgeData.buttonTextColor,
                  borderColor: badgeData.buttonTextColor,
                }}
              >
                <a
                  href={"https://" + badgeData.buttonLinkURL}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: badgeData.buttonTextColor,
                    textDecoration: "none",
                  }}
                >
                  {badgeData.buttonName}
                </a>
              </Button>
            )}
          </div>
          <div>
            {(() => {
              if (!badgeData.videoURL) return null;
              const isYouTubeUrl = badgeData.videoURL.includes('youtube.com') ||
                badgeData.videoURL.includes('youtu.be');

              if (isYouTubeUrl) {
                return (
                  <iframe
                    className="prev-iframe"
                    width="100%"
                    height="315"
                    src={badgeData.videoURL.replace('watch?v=', 'embed/')}
                    title={badgeData.name}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                    style={{ marginTop: "30px" }}
                  />
                );
              } else {
                return (
                  <video
                    width="100%"
                    height="315"
                    controls
                    style={{
                      marginTop: "30px",
                      backgroundColor: "#000",
                      borderRadius: "8px"
                    }}
                    preload="metadata"
                  >
                    <source src={badgeData.videoURL} type="video/mp4" />
                    <source src={badgeData.videoURL} type="video/webm" />
                    <source src={badgeData.videoURL} type="video/ogg" />
                    Your browser does not support the video tag.
                  </video>
                );
              }
            })()}
          </div>
        </>
      </div>

      {loading && (
        <div className="spinner-overlay">
          <div className="spinner" />
        </div>
      )}
    </>
  );
};

export default BadgePreviewDesktop;
